import React from 'react';
import { motion } from 'framer-motion';
import { Snowflake, AlertTriangle, ShieldCheck } from 'lucide-react';
export const PainPoints = () => {
  return <section className="bg-white px-4 py-8 md:py-16 lg:px-8" data-id="element-157">
      <div className="mx-auto max-w-6xl" data-id="element-158">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-8 md:mb-16 text-center" data-id="element-159">
          <h2 className="font-serif text-4xl font-bold text-text-dark md:text-5xl" data-id="element-160">
            Lo que nunca te dirán sobre "congelar comida"
          </h2>
        </motion.div>

        {/* Narrative paragraphs replacing the card grid */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="mb-8 md:mb-16 mx-auto max-w-3xl space-y-6" data-id="element-161">
          <p className="text-xl leading-relaxed text-text-dark" data-id="element-162">
            Te seré muy sincera: antes de crear este método, intenté buscar la
            solución. Pasé noches viendo videos de "expertos" en Batch Cooking y
            guardando recetas de Pinterest.
          </p>
          <p className="text-xl leading-relaxed text-text-dark" data-id="element-163">
            Fue un desastre. Seguramente te ha pasado: congelas algo y, al
            recalentarlo, termina siendo una masa aguada, con sabor a plástico o
            con la carne tan seca que parece cartón. Eso sucede porque la
            mayoría de la información allá afuera te enseña a congelar "sobras"
            o comida ya cocinada.
          </p>

          {/* Hielo Destructor callout */}
          <div className="rounded-2xl bg-gray-50 p-8 shadow-sm" data-id="element-164">
            <div className="flex items-start space-x-4" data-id="element-165">
              <div className="rounded-full bg-white p-3 shadow-sm" data-id="element-166">
                <AlertTriangle className="h-8 w-8 text-terracotta" data-id="element-167" />
              </div>
              <p className="text-lg leading-relaxed text-text-dark" data-id="element-168">
                Ahí es donde el <strong data-id="element-169">"Hielo Destructor"</strong> ataca: quema
                las fibras de tus alimentos y mata el sabor.
              </p>
            </div>
          </div>

          {/* Escudo de Frescura callout */}
          <div className="rounded-2xl bg-gray-50 p-8 shadow-sm" data-id="element-170">
            <div className="flex items-start space-x-4" data-id="element-171">
              <div className="rounded-full bg-white p-3 shadow-sm" data-id="element-172">
                <ShieldCheck className="h-8 w-8 text-sage" data-id="element-173" />
              </div>
              <p className="text-lg leading-relaxed text-text-dark" data-id="element-174">
                Para recuperar tus noches, no necesitas "aprender a cocinar".
                Necesitas una lógica diferente que proteja tus alimentos. Yo lo
                llamo el <strong data-id="element-175">Escudo de Frescura</strong>.
              </p>
            </div>
          </div>
        </motion.div>

        {/* Testimonial Image */}
        <div className="mb-8 md:mb-16 mx-auto max-w-lg" data-id="element-176">
          <img src="https://cdn.magicpatterns.com/uploads/fGBwVmeT19UCvyf3MTCK2c/testimonio2.png" alt="Testimonio de Ana Martínez" className="w-full rounded-xl shadow-md" data-id="element-177" />
        </div>

        {/* Intensely Tested Recipes Image */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-10 md:mt-16 mx-auto max-w-3xl" data-id="element-178">
          <img src="https://cdn.magicpatterns.com/uploads/khc4o1UNL6PthhYVrQ2DsK/3.png" alt="Recetas Rigurosamente Probadas" className="w-full rounded-2xl shadow-lg" data-id="element-179" />
        </motion.div>
      </div>
    </section>;
};